import { useQuery, useMutation, useQueryClient } from "react-query";
import adminApi from "../api/adminApi";

export const useRegisteredDonorsList = (params) => {
  return useQuery(
    ["admin-registered-donors", params],
    () => adminApi.listDonors(params),
    { keepPreviousData: true }
  );
};

export const useRegisteredDonor = (id) => {
  return useQuery(
    ["admin-registered-donor", id],
    () => adminApi.getDonor(id),
    { enabled: !!id }
  );
};

export const useUpdateRegisteredDonor = () => {
  const qc = useQueryClient();
  return useMutation(
    ({ id, data }) => adminApi.updateDonor(id, data),
    {
      onSuccess: () => {
        qc.invalidateQueries("admin-registered-donors");
      },
    }
  );
};

export const useUpdateDonorStatus = () => {
  const qc = useQueryClient();
  return useMutation(
    ({ id, status }) => adminApi.updateDonorStatus(id, status),
    {
      onSuccess: () => {
        qc.invalidateQueries("admin-registered-donors");
      },
    }
  );
};
